{
    "MOD_EMPTY": "Empty",
    "MOD_MRKII": "Loop Card",
    "MOD_MIM_CLASS_B": "Multi Input Unit",
    "MOD_ZMU_CLASS_A": "Zone Monitor",
    "MOD_ZMU_CLASS_B": "Zone Monitor",
    "MOD_MRM": "Multi Relay Output",
    "MOD_NAC_CLASS_A": "Alarm Circuit",
    "MOD_NAC_CLASS_B": "Alarm Circuit",
    "MOD_NWM": "RS485 Network",
    "MOD_MBM": "MOD_MBM",
    "MOD_232": "RS232 Printer",
    "MOD_TCP": "TCP/IP",
    "MOD_GAS": "Gas Loop",
    "MOD_STD": "Standard Loop",
    "MOD_CO": "CO Loop",
    "SMARTLOOP_LOCAL": "Smartloop Local Devices"
}